import React, { Component } from 'react';
import {Row,Col,Button,Input,Label,Modal,ModalBody} from 'reactstrap';

class LocalPartyMasterFilterForm extends Component {
  state = {
    ifsc: '',
    localPartyPan: '',
    localPartyGstNumber: '',
  };

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen && this.props.currentFilters) {
      this.setState({
        ifsc: this.props.currentFilters.ifsc || '',
        localPartyPan: this.props.currentFilters.localPartyPan || '',
        localPartyGstNumber: this.props.currentFilters.localPartyGstNumber || '',
      });
    }
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleApply = () => {
    this.props.onApply({
      ifsc: this.state.ifsc || null,
      localPartyPan: this.state.localPartyPan || null,
      localPartyGstNumber: this.state.localPartyGstNumber || null,
    });
  };

  handleReset = () => {
    this.setState({
      ifsc: '',
      localPartyPan: '',
      localPartyGstNumber: '',
    }, () => {

      this.props.onApply({
        ifsc: null,
        localPartyPan: null,
        localPartyGstNumber: null,
      });
    });
  };

  renderField = (label, name, value, placeholder) => (
    <div>
      <Label className="mb-1 font-weight-500">{label}</Label>
      <Input
        type="text"
        name={name}
        value={value}
        onChange={this.handleChange}
        placeholder={placeholder}
        className="w-100"
        style={{ height: '38px' }}
      />
    </div>
  );

  render() {
    const { isOpen, toggle } = this.props;
    const { ifsc, localPartyPan, localPartyGstNumber } = this.state;

    return (
      <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
        <ModalBody>
          <Row className="mb-4">
            <Col sm="12">
                <div className="d-flex align-items-center">
                <Label className="mr-2 font-weight-100" style={{ minWidth: '100px' }}>
                    IFSC:
                </Label>
                <Input
                    type="text"
                    name="ifsc"
                    value={this.state.ifsc}
                    onChange={this.handleChange}
                    placeholder="Enter Local Party IFSC"
                    style={{ flex: 1, height: '38px' }}
                />
                </div>
            </Col>

            <Col sm="12">
                <div className="d-flex align-items-center">
                <Label className="mr-1 font-weight-500" style={{ minWidth: '100px' }}>
                    PAN:
                </Label>
                <Input
                    type="text"
                    name="localPartyPan"
                    value={this.state.localPartyPan}
                    onChange={this.handleChange}
                    placeholder="Enter Local Party PAN"
                    style={{ flex: 1, height: '38px' }}
                />
                </div>
            </Col>
            </Row>

            <Row className="mb-4">
            <Col sm="12">
                <div className="d-flex align-items-center">
                <Label className="mr-2 font-weight-500" style={{ minWidth: '100px' }}>
                    GST Number:
                </Label>
                <Input
                    type="text"
                    name="localPartyGstNumber"
                    value={this.state.localPartyGstNumber}
                    onChange={this.handleChange}
                    placeholder="Enter Local Party GST Number"
                    style={{ flex: 1, height: '38px' }}
                />
                </div>
            </Col>
            </Row>


          <div className="d-flex justify-content-between">
            <div className="d-flex">
              <Button outline color="primary" onClick={toggle}>
                Hide Filters
              </Button>

              <Button
                outline
                color="primary"
                className="ml-2"
                onClick={this.handleReset}
              >
                Reset Filters
              </Button>
            </div>

            <Button color="primary" onClick={this.handleApply}>
              Apply
              </Button>
          </div>

        </ModalBody>
      </Modal>
    );
  }
}

export default LocalPartyMasterFilterForm;